export default "__VITE_ASSET__Vmbmm1vx75jqgYklwI_8sA__"